import { render, staticRenderFns } from "./EventHeaderIconBoxMobile.vue?vue&type=template&id=2c93fccb"
import script from "./EventHeaderIconBoxMobile.vue?vue&type=script&lang=js"
export * from "./EventHeaderIconBoxMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports